export function extractFirstAndLastName(fullName?: string) {
  const nameParts: string[] = fullName?.split(' ');

  const firstName: string = nameParts?.shift(); // Get the first part
  const single: boolean = nameParts?.length === 0;
  const lastName: string = single === true ? '' : nameParts?.join(' '); // Concatenate the remaining parts

  return {
    firstName,
    lastName,
    fullName,
    single,
  };
}
